const axios = require("axios");
import router from "../router";
import store from "../store";
import Vue from "vue";
import { getEsData } from "@/api/esdata";

const axiosInstance = axios.create({
    // baseURL: process.env.BACKEND_URL,
    // // 跨域請求set-cookie
    // withCredentials: true
    baseURL: "/api",
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // whatever you want to do with the error
        if (error.response.status == 401) {
            if (router.history.current.name !== "UserInfo") {
                // 只清除使用者資料及群組 query，不可使用 LOGOUT 重置所有狀態，因會使客戶（ex: A8）客製化樣式被重置
                store.commit("SET_USER_DATA", {});
                store.commit("SET_QUERY_GROUPNAME", "");
                router.push({ name: "login", query: {} });
            }
        } else if (error.response.status == 403 && error.response.data.message == "noPayment") {
            new Promise((resolve, reject) => {
                resolve(
                    getEsData({
                        isFuzzySearch: false,
                        esIndex: "rcm-edgegroup",
                        from: 0,
                        sort: [{ modifiedDate: { order: "desc" } }],
                        filters: [
                            {
                                key: "groupName",
                                type: "string",
                                value: store.state.queryGroupName,
                            },
                        ],
                        _source: ["billing", "createdDate"],
                    })
                );
            }).then((success) => {
                // console.log(success.data);
                let createdDate =
                    Number(new Date() - new Date(success.data.mapData[0].createdDate)) / 1000 / 60 / 60 / 24;
                if (createdDate >= 27 && Vue.prototype.$can("read", "billingPermission", "")) {
                    store.commit("RESET_CREDITCARD", store.state.queryGroupName);
                    router.push({ name: "Payment" });
                }
            });
        } else if (error.response.status == 403 && error.response.data.message == "notInDeviceList") {
            // console.log("error.response.status == 403 && error.response.data.message == notInDeviceList");
            store.commit("SET_USER_DATA_ISNEEDTOVALIDATE", true);
            router.push({ name: "VerifyDevice" });
        } else if (error.response.status == 403) {
            store.commit("SET_QUERY_GROUPNAME", "");
            router.push({ path: store.getters.landingPagePath });
        }
        return Promise.reject(error.response);
    }
);

// module.exports = axiosInstance;
export default axiosInstance;



// WEBPACK FOOTER //
// ./src/libs/axiosClient.js